
(function animationOnScroll(){
	addClassAnimation();
	$(window).on('scroll', function(){
		addClassAnimation();
	});

	function addClassAnimation() {
		$('.js-animate').each(function(){
			var $this = $(this);
			var offsetEl = $this.offset();
			if ( offsetEl.top <= $(document).scrollTop() + $(window).height() / 1.2 ) {
				$this.addClass('is-animated');
			};
		});
	};
})()
